import React from 'react';
import { Handshake } from 'lucide-react';
import Reveal from './Reveal';

const FILES_BASE = process.env.REACT_APP_BACKEND_URL;

export const LandingPartners = ({ landing, partners }) => {
  const list = partners || [];

  return (
    <section id="partners" className="border-y border-teal-900/20 bg-[#0A192F]/40 py-20 md:py-28" data-testid="landing-partners">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal>
          <div className="text-center">
            <span className="text-sm font-bold uppercase tracking-wider text-teal-400">{landing?.partners_title || 'شركاؤنا'}</span>
            <h2 className="font-display mt-3 text-2xl font-bold text-white sm:text-3xl" data-testid="landing-partners-subtitle">
              {landing?.partners_subtitle || 'أندية وشركاء يثقون بمنصتنا'}
            </h2>
          </div>
        </Reveal>
      </div>

      {list.length === 0 ? (
        <div className="mx-auto mt-10 max-w-md rounded-2xl border border-white/10 bg-white/[0.02] p-8 text-center" data-testid="landing-partners-empty">
          <Handshake className="mx-auto mb-3 h-8 w-8 text-slate-500" />
          <p className="text-sm text-slate-400">سيتم عرض الشركاء هنا بعد إضافتهم من لوحة السوبر أدمن</p>
        </div>
      ) : (
        <div className="mt-10 overflow-hidden">
          <div className="landing-marquee-track gap-16">
            {[...list, ...list].map((p, i) => (
              <div key={`${p.id}-${i}`} className="flex w-40 flex-shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] p-4 opacity-70 grayscale transition-all hover:opacity-100 hover:grayscale-0">
                {p.logo ? (
                  <img src={p.logo.startsWith('http') ? p.logo : `${FILES_BASE}/api/files/${p.logo}`} alt={p.name} className="h-10 max-w-full object-contain" />
                ) : (
                  <span className="font-display text-base font-bold text-white">{p.name}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default LandingPartners;
